import HeroSection from "~/components/HeroSection/HeroSection.jsx";
import BuildYourBoxMain from "~/components/BuildYourBoxMain/BuildYourBoxMain.jsx";

import "./index.css";

const CustomDynamicBox = () => {
  return (
    <>
      <HeroSection />
      <BuildYourBoxMain />
    </>
  );
};

export default CustomDynamicBox;
